// The LAN party pages at the classic URLs under /v5; the LAN tab is in Matchmaking/route.js.
export default [
  {
    path: '/v5/lan',
    name: 'V5LanHub',
    component: () => import('./LanHubPage.vue'),
  },
  {
    path: '/v5/lan/:slug',
    name: 'V5LanParty',
    component: () => import('./LanPartyPage.vue'),
  },
  {
    path: '/v5/matchmaking/lan/:slug/control-room',
    name: 'V5LanControlRoom',
    component: () => import('./LanControlRoomPage.vue'),
  },
];
